function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.async-iterator.js";
import "core-js/modules/es.symbol.to-string-tag.js";
import "core-js/modules/es.json.to-string-tag.js";
import "core-js/modules/es.math.to-string-tag.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.slice.js";
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import i18n from "i18next";
import i18nxhr from "i18next-xhr-backend";
import CustomEvent from "./customevent";
import browserLanguage from "./browserlanguage";
import { Logger, LOGGER_LEVEL } from "./logger";
import { createElement, normalizeDegree, createMapInfo, normalizeArg } from "./functions";
import EventTarget from "ol/events/Target";
import { transform } from "ol/proj";
import { MaplatMap } from "./map_ex";
import { defaults, DragRotateAndZoom } from "ol/interaction";
import { altKeyOnly } from "ol/events/condition";
import { HistMap } from "./source/histmap";
import { TmsMap } from "./source/tmsmap";
import { mapSourceFactory } from "./source_ex";
import { META_KEYS } from "./source/mixin";
import { recursiveRound } from "./math_ex";
import locales from "./freeze_locales";
import { normalizeLayers, addIdToPoi, normalizeLayer, normalizePoi } from "./normalize_pois";
import { createIconSet, createHtmlFromTemplate } from "./template_works";
import mapboxgl from "mapbox-gl";
import redcircle from "../parts/redcircle.png";
import defaultpin_selected from "../parts/defaultpin_selected.png";
import defaultpin from "../parts/defaultpin.png";
export var MaplatApp = /*#__PURE__*/function (_EventTarget) {
  _inherits(MaplatApp, _EventTarget);
  var _super = _createSuper(MaplatApp);
  function MaplatApp(appOption) {
    var _this;
    _classCallCheck(this, MaplatApp);
    _this = _super.call(this);
    _this.translateUI = false;
    _this.noRotate = false;
    _this.initialRestore = {};
    _this.mapDiv = "map_div";
    _this.restoreSession = false;
    _this.stateBuffer = {};
    _this.overlay = true;
    _this.appLang = "ja";
    _this.timer = undefined;
    _this.startFrom = "";
    _this.vectors = [];
    _this.fakeGps = false;
    _this.__backMapMoving = false;
    _this.__init = true;
    _this.__redrawMarkerBlock = false;
    _this.__redrawMarkerThrottle = [];
    appOption = normalizeArg(appOption);
    _this.appid = appOption.appid || "sample";
    if (appOption.mapboxToken) {
      mapboxgl.accessToken = appOption.mapboxToken;
    }
    if (appOption.googleApiKey) {
      _this.googleApiKey = appOption.googleApiKey;
    }
    _this.mapDiv = appOption.div || "map_div";
    _this.mapDivDocument = document.querySelector("#".concat(_this.mapDiv));
    _this.mapDivDocument.classList.add("maplat");
    _this.logger = new Logger(appOption.debug ? LOGGER_LEVEL.ALL : LOGGER_LEVEL.INFO);
    _this.enableCache = appOption.enableCache || false;
    _this.icon = appOption.icon;
    _this.selectedIcon = appOption.selectedIcon;
    _this.translateUI = appOption.translateUI;
    var setting = appOption.setting;
    _this.lang = appOption.lang;
    if (!_this.lang) {
      _this.lang = browserLanguage();
    }
    if (_this.lang.toLowerCase() == "zh-hk" || _this.lang.toLowerCase() == "zh-hant") _this.lang = "zh-TW";
    if (appOption.restore) {
      if (appOption.restoreSession) _this.restoreSession = true;
      _this.initialRestore = appOption.restore;
    } else if (appOption.restoreSession) {
      _this.restoreSession = true;
      var lastEpoch = parseInt(localStorage.getItem("epoch") || "0");
      var currentTime = Math.floor(new Date().getTime() / 1000);
      if (lastEpoch && currentTime - lastEpoch < 3600) {
        _this.initialRestore.mapID = localStorage.getItem("mapID") || localStorage.getItem("sourceID") || undefined;
        _this.initialRestore.backgroundID = localStorage.getItem("backgroundID") || localStorage.getItem("backID") || undefined;
        _this.initialRestore.position = {
          x: parseFloat(localStorage.getItem("x") || "0"),
          y: parseFloat(localStorage.getItem("y") || "0"),
          zoom: parseFloat(localStorage.getItem("zoom") || "0"),
          rotation: parseFloat(localStorage.getItem("rotation") || "0")
        };
        _this.initialRestore.transparency = parseFloat(localStorage.getItem("transparency") || "0");
        _this.initialRestore.hideMarker = parseInt(localStorage.getItem("hideMarker") || "0");
        _this.initialRestore.hideLayer = localStorage.getItem("hideLayer") || undefined;
      }
    }
    var newElems = createElement("<img id=\"center_circle\" class=\"prevent-default\" alt=\"\" style=\"position:absolute;top:50%;left:50%;margin-top:-10px; margin-left:-10px;\" src=\"".concat(redcircle, "\">"));
    for (var i = newElems.length - 1; i >= 0; i--) {
      _this.mapDivDocument.insertBefore(newElems[i], _this.mapDivDocument.firstChild);
    }
    var prevDefs = _this.mapDivDocument.querySelectorAll(".prevent-default");
    for (var _i = 0; _i < prevDefs.length; _i++) {
      var target = prevDefs[_i];
      target.addEventListener("touchstart", function (evt) {
        evt.preventDefault();
      });
    }
    _this.overlay = "overlay" in appOption ? appOption.overlay : true;
    if (_this.overlay) {
      _this.mapDivDocument.classList.add("with-opacity");
    }
    _this.waitReady = _this.settingLoader(setting).then(function (x) {
      return _this.handleSetting(x, appOption);
    });
    return _this;
  }
  _createClass(MaplatApp, [{
    key: "settingLoader",
    value: function () {
      var _settingLoader = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(setting) {
        var _this2 = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", setting || new Promise(function (resolve, _reject) {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", "apps/".concat(_this2.appid, ".json"), true);
                xhr.responseType = "json";
                xhr.onload = function (_e) {
                  var value = this.response;
                  if (_typeof(value) != "object") value = JSON.parse(value);
                  resolve(value);
                };
                xhr.send();
              }));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function settingLoader(_x) {
        return _settingLoader.apply(this, arguments);
      }
      return settingLoader;
    }()
  }, {
    key: "i18nLoader",
    value: function () {
      var _i18nLoader = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var _this3 = this;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              return _context2.abrupt("return", new Promise(function (resolve, _reject) {
                var localesFlag = Object.keys(locales).length != 0;
                var translib = _this3.translateUI && !localesFlag ? i18n.use(i18nxhr) : i18n;
                translib.init({
                  lng: _this3.lang,
                  fallbackLng: ["en"],
                  backend: {
                    loadPath: "assets/locales/{{lng}}/{{ns}}.json"
                  },
                  resources: localesFlag ? locales : undefined
                }, function (_err, t) {
                  resolve([t, i18n]);
                });
              }));
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      function i18nLoader() {
        return _i18nLoader.apply(this, arguments);
      }
      return i18nLoader;
    }()
  }, {
    key: "sourcesLoader",
    value: function () {
      var _sourcesLoader = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(mapReturnValue) {
        var _this4 = this;
        var dataSource, sourcePromise, commonOption, i, option;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              dataSource = this.appData.sources;
              sourcePromise = [];
              commonOption = {
                homePos: mapReturnValue.homePos,
                defZoom: mapReturnValue.defZoom,
                zoomRestriction: mapReturnValue.zoomRestriction,
                mercMinZoom: mapReturnValue.mercMinZoom,
                mercMaxZoom: mapReturnValue.mercMaxZoom,
                enableCache: this.enableCache,
                key: this.googleApiKey,
                translator: function translator(fragment) {
                  return _this4.translate(fragment);
                }
              };
              for (i = 0; i < dataSource.length; i++) {
                option = dataSource[i];
                sourcePromise.push(mapSourceFactory(option, commonOption));
              }
              return _context3.abrupt("return", Promise.all(sourcePromise));
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function sourcesLoader(_x2) {
        return _sourcesLoader.apply(this, arguments);
      }
      return sourcesLoader;
    }()
  }, {
    key: "handleSetting",
    value: function handleSetting(setting, appOption) {
      var _this5 = this;
      this.appData = normalizeArg(setting);
      if (!this.lang && this.appData.lang) {
        this.lang = this.appData.lang;
      }
      return this.i18nLoader().then(function (x) {
        return _this5.handleI18n(x, appOption);
      });
    }
  }, {
    key: "handleI18n",
    value: function handleI18n(i18nObj, appOption) {
      var _this6 = this;
      this.i18n = i18nObj[1];
      this.t = i18nObj[0];
      var mapReturnValue = this.prepareMap(appOption);
      return normalizeLayers(this.appData.pois || [], this).then(function (x) {
        return _this6.handlePois(x, mapReturnValue);
      });
    }
  }, {
    key: "prepareMap",
    value: function prepareMap(appOption) {
      appOption = normalizeArg(appOption);
      this.mercBuffer = null;
      var homePos = this.appData.homePosition;
      var defZoom = this.appData.defaultZoom;
      var zoomRestriction = this.appData.zoomRestriction;
      var mercMinZoom = this.appData.minZoom;
      var mercMaxZoom = this.appData.maxZoom;
      this.appName = this.appData.appName;
      var fakeGps = appOption.fake ? this.appData.fakeGps : false;
      var fakeRadius = appOption.fake ? this.appData.fakeRadius : false;
      this.appLang = this.appData.lang || "ja";
      this.noRotate = appOption.noRotate || this.appData.noRotate || false;
      this.poiTemplate = appOption.poiTemplate || this.appData.poiTemplate || false;
      this.poiStyle = appOption.poiStyle || this.appData.poiStyle || false;
      this.iconTemplate = appOption.iconTemplate || this.appData.iconTemplate || false;
      this.currentPosition = null;
      this.__init = true;
      this.dispatchEvent(new CustomEvent("uiPrepare"));
      var frontDiv = "".concat(this.mapDiv, "_front");
      var newElem = createElement("<div id=\"".concat(frontDiv, "\" class=\"map\" style=\"top:0; left:0; right:0; bottom:0; ") + "position:absolute;\"></div>")[0];
      this.mapDivDocument.insertBefore(newElem, this.mapDivDocument.firstChild);
      this.fakeGps = fakeGps;
      this.fakeRadius = fakeRadius;
      this.homePosition = homePos;
      this.mapObject = new MaplatMap({
        div: frontDiv,
        controls: this.appData.controls || [],
        interactions: this.noRotate ? defaults({
          altShiftDragRotate: false,
          pinchRotate: false
        }) : defaults().extend([new DragRotateAndZoom({
          condition: altKeyOnly
        })]),
        fakeGps: fakeGps,
        fakeRadius: fakeRadius,
        homePosition: homePos,
        northUp: appOption.northUp || this.appData.northUp || false,
        tapDuration: appOption.tapDuration || this.appData.tapDuration || 3000,
        homeMarginPixels: appOption.homeMarginPixels || this.appData.homeMarginPixels || 50,
        tapUIVanish: appOption.tapUIVanish || this.appData.tapUIVanish || false,
        alwaysGpsOn: appOption.alwaysGpsOn || false
      });
      var backDiv = null;
      if (this.overlay) {
        backDiv = "".concat(this.mapDiv, "_back");
        newElem = createElement("<div id=\"".concat(backDiv, "\" class=\"map\" style=\"top:0; left:0; right:0; bottom:0; ") + "position:absolute;\"></div>")[0];
        this.mapDivDocument.insertBefore(newElem, this.mapDivDocument.firstChild);
        this.backMap = new MaplatMap({
          off_control: true,
          div: backDiv
        });
      }
      if (mapboxgl) {
        var mapboxDiv = "".concat(this.mapDiv, "_mapbox");
        newElem = createElement("<div id=\"".concat(mapboxDiv, "\" class=\"map\" style=\"top:0; left:0; right:0; bottom:0; ") + "position:absolute;visibility:hidden;\"></div>")[0];
        this.mapDivDocument.insertBefore(newElem, this.mapDivDocument.firstChild);
        this.mapboxMap = new mapboxgl.Map({
          attributionControl: false,
          boxZoom: false,
          container: mapboxDiv,
          doubleClickZoom: false,
          dragPan: false,
          dragRotate: false,
          interactive: false,
          keyboard: false,
          pitchWithRotate: false,
          scrollZoom: false,
          touchZoomRotate: false
        });
      }
      this.startFrom = this.appData.startFrom;
      return {
        homePos: homePos,
        defZoom: defZoom,
        zoomRestriction: zoomRestriction,
        mercMinZoom: mercMinZoom,
        mercMaxZoom: mercMaxZoom
      };
    }
  }, {
    key: "handlePois",
    value: function handlePois(pois, mapReturnValue) {
      var _this7 = this;
      this.pois = pois;
      return this.sourcesLoader(mapReturnValue).then(function (x) {
        return _this7.handleSources(x);
      });
    }
  }, {
    key: "handleSources",
    value: function handleSources(sources) {
      this.mercSrc = sources.reduce(function (prev, curr) {
        if (prev) return prev;
        if (curr.isBasemap()) return curr;
      }, null);
      var cache = [];
      this.cacheHash = {};
      for (var i = 0; i < sources.length; i++) {
        var source = sources[i];
        source.setMap(this.mapObject);
        if (source.isMapbox()) {
          if (!this.mapboxMap) {
            throw "To use mapbox gl based base map, you have to make Maplat object with specifying 'mapboxgl' option.";
          }
          source.mapboxMap = this.mapboxMap;
        }
        cache.push(source);
        this.cacheHash[source.mapID] = source;
      }
      this.dispatchEvent(new CustomEvent("sourceLoaded", sources));
      this.setInitialMap(cache);
      this.setMapClick();
      this.setPointerEvents();
      this.setMapOnOff();
      this.setMouseCursor();
      this.setBackMapBehavior();
      this.raiseChangeViewpoint();
    }
  }, {
    key: "setInitialMap",
    value: function () {
      var _setInitialMap = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(cache) {
        var initial;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              initial = this.initialRestore.mapID || this.startFrom || cache[cache.length - 1].mapID;
              this.from = cache.reduce(function (prev, curr) {
                if (prev) {
                  return !(prev instanceof HistMap) && curr.mapID != initial ? curr : prev;
                }
                if (curr.mapID != initial) return curr;
                return prev;
              }, undefined);
              _context4.next = 4;
              return this.changeMap(initial, this.initialRestore);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function setInitialMap(_x3) {
        return _setInitialMap.apply(this, arguments);
      }
      return setInitialMap;
    }()
  }, {
    key: "setMapClick",
    value: function setMapClick() {
      var _this8 = this;
      this.mapObject.on("click", function (evt) {
        _this8.logger.debug(evt.pixel);
        _this8.lastClickEvent = evt;
        var features = [];
        evt.target.forEachFeatureAtPixel(evt.pixel, function (feature) {
          _this8.logger.debug(evt.pixel);
          if (feature.get("datum")) features.push(feature.get("datum"));
        });
        if (features.length > 0) {
          _this8.dispatchEvent(new CustomEvent("clickMarker", features[0]));
          _this8.dispatchEvent(new CustomEvent("clickMarkers", features));
        } else {
          var xy = evt.coordinate;
          _this8.dispatchEvent(new CustomEvent("clickMapXy", xy));
          _this8.from.sysCoord2MercAsync(xy).then(function (merc) {
            _this8.dispatchEvent(new CustomEvent("clickMapMerc", merc));
            var lnglat = transform(merc, "EPSG:3857", "EPSG:4326");
            _this8.dispatchEvent(new CustomEvent("clickMap", {
              longitude: lnglat[0],
              latitude: lnglat[1]
            }));
          });
        }
      });
    }
  }, {
    key: "setPointerEvents",
    value: function setPointerEvents() {
      var _this9 = this;
      var xyBuffer;
      var waiting = false;
      var dragging = false;
      var pointerCounter = {};
      var pointermoveHandler = function pointermoveHandler(xy) {
        _this9.dispatchEvent(new CustomEvent("pointerMoveOnMapXy", xy));
        _this9.from.sysCoord2MercAsync(xy).then(function (merc) {
          _this9.dispatchEvent(new CustomEvent("pointerMoveOnMapMerc", merc));
          if (xyBuffer) {
            var next = xyBuffer;
            xyBuffer = false;
            pointermoveHandler(next);
          } else {
            waiting = false;
          }
        });
      };
      this.mapObject.on("pointermove", function (evt) {
        if (dragging) return;
        if (waiting) {
          xyBuffer = evt.coordinate;
        } else {
          waiting = true;
          pointermoveHandler(evt.coordinate);
        }
      });
      this.mapObject.on("pointerdown", function (evt) {
        if (evt.originalEvent && evt.originalEvent.pointerId != null) {
          pointerCounter[evt.originalEvent.pointerId] = true;
        }
        dragging = true;
      });
      this.mapObject.on("pointerdrag", function (evt) {
        if (evt.originalEvent && evt.originalEvent.pointerId != null) {
          pointerCounter[evt.originalEvent.pointerId] = true;
        }
        dragging = true;
      });
      this.mapObject.on("pointerup", function (evt) {
        if (evt.originalEvent && evt.originalEvent.pointerId != null) {
          delete pointerCounter[evt.originalEvent.pointerId];
          if (Object.keys(pointerCounter).length == 0) {
            dragging = false;
          }
        } else if (evt.originalEvent && evt.originalEvent.touches) {
          if (evt.originalEvent.touches.length == 0) {
            dragging = false;
          }
        } else {
          dragging = false;
        }
      });
    }
  }, {
    key: "setMapOnOff",
    value: function setMapOnOff() {
      var _this10 = this;
      var timer;
      this.mapObject.on("click", function () {
        if (timer) {
          clearTimeout(timer);
          timer = undefined;
        }
        var ctls = _this10.mapDivDocument.querySelectorAll(".ol-control");
        if (!_this10.mapObject.tapUIVanish || ctls.length && ctls[0].classList.contains("fade")) {
          for (var i = 0; i < ctls.length; i++) {
            ctls[i].classList.remove("fade");
          }
        } else {
          for (var _i2 = 0; _i2 < ctls.length; _i2++) {
            ctls[_i2].classList.add("fade");
          }
          timer = setTimeout(function () {
            timer = undefined;
            var ctls = _this10.mapDivDocument.querySelectorAll(".ol-control");
            for (var _i3 = 0; _i3 < ctls.length; _i3++) {
              ctls[_i3].classList.remove("fade");
            }
          }, _this10.mapObject.tapDuration);
        }
      });
      this.mapObject.on("pointerdrag", function () {
        if (timer) {
          clearTimeout(timer);
          timer = undefined;
        }
        var ctls = _this10.mapDivDocument.querySelectorAll(".ol-control");
        for (var i = 0; i < ctls.length; i++) {
          ctls[i].classList.add("fade");
        }
      });
      this.mapObject.on("moveend", function () {
        if (timer) {
          clearTimeout(timer);
          timer = undefined;
        }
        timer = setTimeout(function () {
          timer = undefined;
          var ctls = _this10.mapDivDocument.querySelectorAll(".ol-control");
          for (var i = 0; i < ctls.length; i++) {
            ctls[i].classList.remove("fade");
          }
        }, _this10.mapObject.tapDuration);
      });
    }
  }, {
    key: "setMouseCursor",
    value: function setMouseCursor() {
      var _this11 = this;
      var moveHandler = function moveHandler(evt) {
        var pixel = evt.target.getEventPixel(evt.originalEvent);
        var hit = evt.target.hasFeatureAtPixel(pixel);
        var target = evt.target.getTarget();
        if (hit) {
          var feature = evt.target.forEachFeatureAtPixel(evt.pixel, function (feature) {
            if (feature.get("datum")) return feature;
          });
          _this11.mapDivDocument.querySelector("#".concat(target)).style.cursor = feature ? "pointer" : "";
          return;
        }
        _this11.mapDivDocument.querySelector("#".concat(target)).style.cursor = "";
      };
      this.mapObject.on("pointermove", moveHandler);
      var mapOutHandler = function mapOutHandler(evt) {
        var histCoord = evt.frameState.viewState.center;
        var source = _this11.from;
        if (!source.insideCheckSysCoord(histCoord)) {
          histCoord = source.modulateSysCoordInside(histCoord);
          evt.target.getView().setCenter(histCoord);
        }
      };
      this.mapObject.on("moveend", mapOutHandler);
    }
  }, {
    key: "setBackMapBehavior",
    value: function setBackMapBehavior() {
      var _this12 = this;
      var backMapMove = function backMapMove(_evt) {
        if (!_this12.backMap) return;
        if (_this12.__backMapMoving) {
          _this12.logger.debug("Backmap moving skipped");
          return;
        }
        var backSrc = _this12.backMap.getSource();
        if (backSrc) {
          _this12.__backMapMoving = true;
          _this12.logger.debug("Backmap moving started");
          _this12.convertParametersFromCurrent(backSrc, function (size) {
            var view = _this12.backMap.getView();
            view.setCenter(size[0]);
            view.setZoom(size[1]);
            view.setRotation(_this12.noRotate ? 0 : size[2]);
            _this12.logger.debug("Backmap moving ended");
            _this12.__backMapMoving = false;
          });
        }
      };
      this.mapObject.on("postrender", backMapMove);
    }
  }, {
    key: "raiseChangeViewpoint",
    value: function raiseChangeViewpoint() {
      var _this13 = this;
      this.mapObject.on("postrender", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_evt) {
          var view, center, zoom, rotation, mercs, viewpoint, ll, direction;
          return _regeneratorRuntime().wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                view = _this13.mapObject.getView();
                center = view.getCenter();
                zoom = view.getDecimalZoom();
                rotation = normalizeDegree(view.getRotation() * 180 / Math.PI);
                _context5.next = 6;
                return _this13.from.viewpoint2MercsAsync();
              case 6:
                mercs = _context5.sent;
                _context5.next = 9;
                return _this13.mercSrc.mercs2ViewpointAsync(mercs);
              case 9:
                viewpoint = _context5.sent;
                if (!(_this13.mobileMapMoveBuffer && _this13.mobileMapMoveBuffer[0][0] == viewpoint[0][0] && _this13.mobileMapMoveBuffer[0][1] == viewpoint[0][1] && _this13.mobileMapMoveBuffer[1] == viewpoint[1] && _this13.mobileMapMoveBuffer[2] == viewpoint[2])) {
                  _context5.next = 12;
                  break;
                }
                return _context5.abrupt("return");
              case 12:
                _this13.mobileMapMoveBuffer = viewpoint;
                ll = transform(viewpoint[0], "EPSG:3857", "EPSG:4326");
                direction = normalizeDegree(viewpoint[2] * 180 / Math.PI);
                _this13.dispatchEvent(new CustomEvent("changeViewpoint", {
                  x: center[0],
                  y: center[1],
                  longitude: ll[0],
                  latitude: ll[1],
                  mercator_x: viewpoint[0][0],
                  mercator_y: viewpoint[0][1],
                  zoom: zoom,
                  mercZoom: viewpoint[1],
                  direction: direction,
                  rotation: rotation
                }));
                _this13.requestUpdateState({
                  position: {
                    x: center[0],
                    y: center[1],
                    zoom: zoom,
                    rotation: rotation
                  }
                });
              case 17:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x4) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "currentMapInfo",
    value: function currentMapInfo() {
      return createMapInfo(this.from);
    }
  }, {
    key: "mapInfo",
    value: function mapInfo(mapID) {
      return createMapInfo(this.cacheHash[mapID]);
    }
  }, {
    key: "setMarker",
    value: function setMarker(data) {
      var _this14 = this;
      this.logger.debug(data);
      var lnglat = data.lnglat || [data.lng || data.longitude, data.lat || data.latitude];
      var x = data.x;
      var y = data.y;
      var coords = data.coordinates;
      var src = this.from;
      var icon = data.icon ? this.__selectedMarker == data.namespaceID && data.selectedIcon ? data.selectedIcon : data.icon : this.__selectedMarker == data.namespaceID ? defaultpin_selected : defaultpin;
      var promise = coords ? function () {
        return src.merc2SysCoordAsync_ignoreBackground(coords);
      }() : x && y ? new Promise(function (resolve) {
        resolve(src.xy2SysCoord([x, y]));
      }) : function () {
        var merc = transform(lnglat, "EPSG:4326", "EPSG:3857");
        return src.merc2SysCoordAsync_ignoreBackground(merc);
      }();
      return promise.then(function (xy) {
        if (!xy) return;
        if (src.insideCheckSysCoord(xy)) {
          _this14.mapObject.setMarker(xy, {
            datum: data
          }, icon);
        }
      });
    }
  }, {
    key: "resetMarker",
    value: function resetMarker() {
      this.mapObject.resetMarker();
    }
  }, {
    key: "setLine",
    value: function setLine(data) {
      data.type = "Line";
      if (!data.style && data.stroke) {
        data.style = {
          stroke: data.stroke
        };
      }
      this.setVector(data);
    }
  }, {
    key: "setVector",
    value: function setVector(data) {
      var _this15 = this;
      this.logger.debug(data);
      var xyPromises;
      var merc2XyRecurse = function merc2XyRecurse(coords) {
        var isLnglat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        return Promise.all(coords.map(function (coord) {
          if (Array.isArray(coord[0])) {
            return merc2XyRecurse(coord, isLnglat);
          } else {
            if (isLnglat) coord = transform(coord, "EPSG:4326", "EPSG:3857");
            return _this15.from.merc2SysCoordAsync(coord);
          }
        }));
      };
      if (data.coordinates) {
        xyPromises = merc2XyRecurse(data.coordinates);
      } else {
        xyPromises = merc2XyRecurse(data.lnglats, true);
      }
      xyPromises.then(function (xys) {
        _this15.mapObject.setVector(xys, data.type, data.style);
      });
    }
  }, {
    key: "resetLine",
    value: function resetLine() {
      this.resetVector();
    }
  }, {
    key: "resetVector",
    value: function resetVector() {
      this.mapObject.resetVector();
    }
  }, {
    key: "redrawMarkers",
    value: function redrawMarkers() {
      var _this16 = this;
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : undefined;
      if (!source) {
        source = this.from;
      }
      if (this.__redrawMarkerBlock) {
        if (!this.__redrawMarkerThrottle) this.__redrawMarkerThrottle = [];
        var throttle = this.__redrawMarkerThrottle;
        if (throttle.length == 0 || throttle[throttle.length - 1] !== source) {
          throttle.push(source);
          return;
        }
      }
      this.__redrawMarkerBlock = true;
      var redrawLogic = function redrawLogic(source) {
        var promises = [];
        _this16.resetMarker();
        var selected;
        if (!_this16.stateBuffer.hideMarker) {
          Object.keys(_this16.pois).map(function (key) {
            var cluster = _this16.pois[key];
            if (!cluster.hide) {
              cluster.pois.map(function (data) {
                var dataCopy = createIconSet(data, cluster, _this16);
                createHtmlFromTemplate(dataCopy, cluster, _this16);
                if (_this16.__selectedMarker == dataCopy.namespaceID) {
                  selected = dataCopy;
                } else {
                  promises.push(_this16.setMarker(dataCopy));
                }
              });
            }
          });
          if (source.pois) {
            Object.keys(source.pois).map(function (key) {
              var cluster = source.pois[key];
              if (!cluster.hide) {
                cluster.pois.map(function (data) {
                  var dataCopy = createIconSet(data, cluster, source, _this16);
                  createHtmlFromTemplate(dataCopy, cluster, source, _this16);
                  if (_this16.__selectedMarker == dataCopy.namespaceID) {
                    selected = dataCopy;
                  } else {
                    promises.push(_this16.setMarker(dataCopy));
                  }
                });
              }
            });
          }
        }
        var promise_var = Promise.all(promises);
        if (selected) {
          promise_var = promise_var.then(function () {
            return _this16.setMarker(selected);
          });
        }
        promise_var.then(function () {
          if (_this16.__redrawMarkerThrottle && _this16.__redrawMarkerThrottle.length > 0) {
            redrawLogic(_this16.__redrawMarkerThrottle.shift());
          } else {
            _this16.__redrawMarkerBlock = false;
          }
        });
      };
      redrawLogic(source);
    }
  }, {
    key: "selectMarker",
    value: function selectMarker(id) {
      var data = this.getMarker(id);
      if (!data) return;
      this.__selectedMarker = id;
      var latlng = {
        latitude: data.lnglat ? data.lnglat[1] : data.lat ? data.lat : data.latitude,
        longitude: data.lnglat ? data.lnglat[0] : data.lng ? data.lng : data.longitude
      };
      this.setViewpoint(latlng);
      this.redrawMarkers();
    }
  }, {
    key: "unselectMarker",
    value: function unselectMarker() {
      delete this.__selectedMarker;
      this.redrawMarkers();
    }
  }, {
    key: "getMarker",
    value: function getMarker(id) {
      var _this17 = this;
      if (id.indexOf("#") < 0) {
        var ret = undefined;
        Object.keys(this.pois).map(function (key) {
          _this17.pois[key].pois.map(function (poi, i) {
            if (poi.id == id) {
              ret = _this17.pois[key].pois[i];
            }
          });
        });
        return ret;
      } else {
        var splits = id.split("#");
        var source = this.cacheHash[splits[0]];
        if (source) {
          return source.getPoi(splits[1]);
        }
      }
    }
  }, {
    key: "updateMarker",
    value: function updateMarker(id, data, overwrite) {
      var poi = this.getMarker(id);
      if (!poi) return;
      data = normalizePoi(data || {});
      if (overwrite) {
        Object.keys(poi).map(function (key) {
          if (key != "id" && key != "namespaceID") {
            delete poi[key];
          }
        });
        Object.assign(poi, data);
      } else {
        Object.keys(data).map(function (key) {
          if (key == "id" || key == "namespaceID") return;
          if (data[key] == "____delete____") {
            delete poi[key];
          } else {
            poi[key] = data[key];
          }
        });
      }
      this.redrawMarkers();
    }
  }, {
    key: "addMarker",
    value: function addMarker(data, clusterId) {
      if (!clusterId) {
        clusterId = "main";
      }
      if (clusterId.indexOf("#") < 0) {
        if (this.pois[clusterId]) {
          this.pois[clusterId]["pois"].push(normalizePoi(data));
          addIdToPoi(this.pois, clusterId, {
            name: this.appName
          });
          this.dispatchPoiNumber();
          this.redrawMarkers();
          return data.namespaceID;
        }
      } else {
        var splits = clusterId.split("#");
        var source = this.cacheHash[splits[0]];
        if (source) {
          var ret = source.addPoi(data, splits[1]);
          this.dispatchPoiNumber();
          this.redrawMarkers();
          return ret;
        }
      }
    }
  }, {
    key: "removeMarker",
    value: function removeMarker(id) {
      var _this18 = this;
      if (id.indexOf("#") < 0) {
        Object.keys(this.pois).map(function (key) {
          _this18.pois[key].pois.map(function (poi, i) {
            if (poi.id == id) {
              delete _this18.pois[key].pois[i];
              _this18.dispatchPoiNumber();
              _this18.redrawMarkers();
            }
          });
        });
      } else {
        var splits = id.split("#");
        var source = this.cacheHash[splits[0]];
        if (source) {
          source.removePoi(splits[1]);
          this.dispatchPoiNumber();
          this.redrawMarkers();
        }
      }
    }
  }, {
    key: "clearMarker",
    value: function clearMarker(clusterId) {
      var _this19 = this;
      if (!clusterId) {
        clusterId = "main";
      }
      if (clusterId.indexOf("#") < 0) {
        if (clusterId == "all") {
          Object.keys(this.pois).map(function (key) {
            _this19.pois[key]["pois"] = [];
          });
        } else if (this.pois[clusterId]) {
          this.pois[clusterId]["pois"] = [];
        } else return;
        this.dispatchPoiNumber();
        this.redrawMarkers();
      } else {
        var splits = clusterId.split("#");
        var source = this.cacheHash[splits[0]];
        if (source) {
          source.clearPoi(splits[1]);
          this.dispatchPoiNumber();
          this.redrawMarkers();
        }
      }
    }
  }, {
    key: "showAllMarkers",
    value: function showAllMarkers() {
      this.requestUpdateState({
        hideMarker: 0
      });
      this.redrawMarkers();
    }
  }, {
    key: "hideAllMarkers",
    value: function hideAllMarkers() {
      this.requestUpdateState({
        hideMarker: 1
      });
      this.redrawMarkers();
    }
  }, {
    key: "dispatchPoiNumber",
    value: function dispatchPoiNumber() {
      this.dispatchEvent(new CustomEvent("poi_number", this.listPoiLayers(false, true).reduce(function (prev, curr) {
        return prev + curr.pois.length;
      }, 0)));
    }
  }, {
    key: "listPoiLayers",
    value: function listPoiLayers() {
      var _this20 = this;
      var hideOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var nonzero = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var appPois = Object.keys(this.pois).sort(function (a, b) {
        if (a == "main") return -1;else if (b == "main") return 1;else if (a < b) return -1;else if (a > b) return 1;else return 0;
      }).map(function (key) {
        return _this20.pois[key];
      }).filter(function (layer) {
        return nonzero ? hideOnly ? layer.pois.length && layer.hide : layer.pois.length : hideOnly ? layer.hide : true;
      });
      var mapPois = this.from.listPoiLayers(hideOnly, nonzero);
      return appPois.concat(mapPois);
    }
  }, {
    key: "showPoiLayer",
    value: function showPoiLayer(id) {
      var layer = this.getPoiLayer(id);
      if (layer) {
        delete layer.hide;
        this.requestUpdateState({
          hideLayer: this.listPoiLayers(true).map(function (layer) {
            return layer.namespaceID;
          }).join(",")
        });
        this.redrawMarkers();
      }
    }
  }, {
    key: "hidePoiLayer",
    value: function hidePoiLayer(id) {
      var layer = this.getPoiLayer(id);
      if (layer) {
        layer.hide = true;
        this.requestUpdateState({
          hideLayer: this.listPoiLayers(true).map(function (layer) {
            return layer.namespaceID;
          }).join(",")
        });
        this.redrawMarkers();
      }
    }
  }, {
    key: "getPoiLayer",
    value: function getPoiLayer(id) {
      if (id.indexOf("#") < 0) {
        return this.pois[id];
      } else {
        var splits = id.split("#");
        var source = this.cacheHash[splits[0]];
        if (source) {
          return source.getPoiLayer(splits[1]);
        }
      }
    }
  }, {
    key: "addPoiLayer",
    value: function addPoiLayer(id, data) {
      if (id == "main") return;
      if (this.pois[id]) return;
      if (id.indexOf("#") < 0) {
        this.pois[id] = normalizeLayer(data || [], id, {
          name: this.appName
        });
        this.redrawMarkers();
      } else {
        var splits = id.split("#");
        var source = this.cacheHash[splits[0]];
        if (source) {
          source.addPoiLayer(splits[1], data);
          this.redrawMarkers();
        }
      }
    }
  }, {
    key: "removePoiLayer",
    value: function removePoiLayer(id) {
      if (id == "main") return;
      if (!this.pois[id]) return;
      if (id.indexOf("#") < 0) {
        delete this.pois[id];
        this.requestUpdateState({
          hideLayer: this.listPoiLayers(true).map(function (layer) {
            return layer.namespaceID;
          }).join(",")
        });
        this.dispatchPoiNumber();
        this.redrawMarkers();
      } else {
        var splits = id.split("#");
        var source = this.cacheHash[splits[0]];
        if (source) {
          source.removePoiLayer(splits[1]);
          this.requestUpdateState({
            hideLayer: this.listPoiLayers(true).map(function (layer) {
              return layer.namespaceID;
            }).join(",")
          });
          this.dispatchPoiNumber();
          this.redrawMarkers();
        }
      }
    }
  }, {
    key: "addLine",
    value: function addLine(data) {
      this.vectors.push(data);
      this.setLine(data);
    }
  }, {
    key: "addVector",
    value: function addVector(data) {
      this.vectors.push(data);
      this.setVector(data);
    }
  }, {
    key: "clearLine",
    value: function clearLine() {
      this.vectors = [];
      this.resetLine();
    }
  }, {
    key: "clearVector",
    value: function clearVector() {
      this.vectors = [];
      this.resetVector();
    }
  }, {
    key: "setGPSMarker",
    value: function setGPSMarker(position) {
      this.currentPosition = position;
      this.from.setGPSMarker(position, true);
    }
  }, {
    key: "changeMap",
    value: function changeMap(mapID, restore) {
      var _this21 = this;
      if (restore === undefined) restore = {};
      var now = this.mercSrc;
      var to = this.cacheHash[mapID];
      if (!this.changeMapSeq) {
        this.changeMapSeq = Promise.resolve();
      }
      return this.changeMapSeq = this.changeMapSeq.then(function () {
        return new Promise(function (resolve, _reject) {
          _this21.convertParametersFromCurrent(to, function (size) {
            var backSrc = null;
            var backTo = null;
            var backRestore = restore.backgroundID ? _this21.cacheHash[restore.backgroundID] : undefined;
            if (_this21.backMap) {
              backSrc = _this21.backMap.getSource();
              if (!to.isWmts()) {
                if (backRestore) {
                  backTo = backRestore;
                  _this21.backMap.exchangeSource(backTo);
                } else {
                  if (!backSrc) {
                    backTo = now;
                    if (_this21.from.isWmts()) {
                      backTo = _this21.from instanceof TmsMap ? _this21.mapObject.getSource() : _this21.from;
                    }
                    _this21.backMap.exchangeSource(backTo);
                  } else {
                    backTo = backSrc;
                  }
                }
                _this21.requestUpdateState({
                  backgroundID: backTo.mapID
                });
              } else {
                _this21.backMap.exchangeSource();
              }
            }
            if (to instanceof TmsMap) {
              _this21.mapObject.setLayer(to);
              if (backRestore) {
                _this21.mapObject.exchangeSource(backRestore);
              } else if (!_this21.from.isWmts()) {
                var backToLocal = backSrc || now;
                _this21.mapObject.exchangeSource(backToLocal);
              }
              _this21.requestUpdateState({
                backgroundID: _this21.mapObject.getSource().mapID
              });
            } else {
              _this21.mapObject.setLayer();
              _this21.mapObject.exchangeSource(to);
            }
            var updateState = {
              mapID: to.mapID
            };
            if (to.isBasemap()) {
              updateState.backgroundID = "____delete____";
            }
            _this21.requestUpdateState(updateState);
            _this21.from = to;
            _this21.dispatchPoiNumber();
            var view = _this21.mapObject.getView();
            if (_this21.appData.zoomRestriction) {
              view.setMaxZoom(to.maxZoom);
              view.setMinZoom(to.minZoom || 0);
            }
            if (to.insideCheckSysCoord(size[0])) {
              view.setCenter(size[0]);
              view.setZoom(size[1]);
              view.setRotation(_this21.noRotate ? 0 : size[2]);
            } else if (!_this21.__init) {
              _this21.dispatchEvent(new CustomEvent("outOfMap", {}));
              _this21.goHome(to);
            }
            to.setGPSMarker(_this21.currentPosition, true);
            if (restore.hideLayer) {
              var layers = restore.hideLayer.split(",");
              layers.map(function (key) {
                var layer = _this21.getPoiLayer(key);
                if (layer) {
                  layer.hide = true;
                }
              });
              _this21.requestUpdateState({
                hideLayer: restore.hideLayer
              });
            }
            if (restore.hideMarker) {
              _this21.hideAllMarkers();
            } else {
              _this21.redrawMarkers();
            }
            _this21.resetVector();
            for (var i = 0; i < _this21.vectors.length; i++) {
              (function (data) {
                _this21.setVector(data);
              })(_this21.vectors[i]);
            }
            _this21.dispatchEvent(new CustomEvent("mapChanged", _this21.getMapMeta(to.mapID)));
            _this21.mapObject.updateSize();
            _this21.mapObject.render();
            if (restore.position) {
              _this21.__init = false;
              to.setViewpoint(restore.position);
            }
            if (restore.transparency) {
              _this21.setTransparency(restore.transparency);
            }
            if (_this21.__init) {
              _this21.__init = false;
              _this21.goHome(to);
            } else if (_this21.backMap && backTo) {
              _this21.convertParametersFromCurrent(backTo, function (size) {
                var view = _this21.backMap.getView();
                view.setCenter(size[0]);
                view.setZoom(size[1]);
                view.setRotation(_this21.noRotate ? 0 : size[2]);
                _this21.backMap.updateSize();
                _this21.backMap.render();
              });
            }
            resolve(undefined);
          });
        });
      });
    }
  }, {
    key: "requestUpdateState",
    value: function requestUpdateState(data) {
      var _this22 = this;
      this.stateBuffer = Object.assign(this.stateBuffer, data);
      if (this.stateBuffer.backgroundID == "____delete____") {
        delete this.stateBuffer.backgroundID;
      }
      if (this.restoreSession) {
        var currentTime = Math.floor(new Date().getTime() / 1000);
        localStorage.setItem("epoch", "".concat(currentTime));
        var loopSession = function loopSession(data) {
          Object.keys(data).map(function (key) {
            if (key == "position") {
              loopSession(data[key]);
            } else if (key == "backgroundID" && data[key] == "____delete____") {
              localStorage.removeItem(key);
            } else {
              localStorage.setItem(key, data[key]);
            }
          });
        };
        loopSession(data);
      }
      if (this.timer) clearTimeout(this.timer);
      this.timer = setTimeout(function () {
        _this22.timer = undefined;
        _this22.dispatchEvent(new CustomEvent("updateState", _this22.stateBuffer));
      }, 50);
    }
  }, {
    key: "setTransparency",
    value: function setTransparency(percentage) {
      this.__transparency = percentage;
      this.mapObject.setTransparency(percentage);
      this.requestUpdateState({
        transparency: percentage
      });
    }
  }, {
    key: "getTransparency",
    value: function getTransparency() {
      return this.__transparency == null ? 0 : this.__transparency;
    }
  }, {
    key: "setViewpoint",
    value: function setViewpoint(cond) {
      this.from.setViewpoint(cond);
    }
  }, {
    key: "goHome",
    value: function goHome(useTo) {
      var src = useTo || this.from;
      src.goHome();
    }
  }, {
    key: "resetRotation",
    value: function resetRotation() {
      this.from.resetRotation();
    }
  }, {
    key: "resetDirection",
    value: function resetDirection() {
      this.from.resetDirection();
    }
  }, {
    key: "resetCirculation",
    value: function resetCirculation() {
      this.from.resetCirculation();
    }
  }, {
    key: "getMapMeta",
    value: function getMapMeta(mapID) {
      var source;
      if (!mapID) {
        source = this.from;
      } else {
        source = this.cacheHash[mapID];
      }
      if (!source) return;
      return META_KEYS.reduce(function (prev, curr) {
        prev[curr] = source.get(curr);
        return prev;
      }, {
        mapID: source.mapID,
        label: source.label
      });
    }
  }, {
    key: "getMapCacheEnable",
    value: function getMapCacheEnable(mapID) {
      var source;
      if (!mapID) {
        source = this.from;
      } else {
        source = this.cacheHash[mapID];
      }
      if (!source) return false;
      return source.getCacheEnable();
    }
  }, {
    key: "getMapTileCacheStatsAsync",
    value: function () {
      var _getMapTileCacheStatsAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6(mapID) {
        var source;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              if (!mapID) {
                source = this.from;
              } else {
                source = this.cacheHash[mapID];
              }
              if (source) {
                _context6.next = 3;
                break;
              }
              return _context6.abrupt("return", {});
            case 3:
              _context6.next = 5;
              return source.getTileCacheStatsAsync();
            case 5:
              return _context6.abrupt("return", _context6.sent);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function getMapTileCacheStatsAsync(_x5) {
        return _getMapTileCacheStatsAsync.apply(this, arguments);
      }
      return getMapTileCacheStatsAsync;
    }()
  }, {
    key: "getMapTileCacheSizeAsync",
    value: function () {
      var _getMapTileCacheSizeAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(mapID) {
        var stats;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return this.getMapTileCacheStatsAsync(mapID);
            case 2:
              stats = _context7.sent;
              return _context7.abrupt("return", stats.size || 0);
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function getMapTileCacheSizeAsync(_x6) {
        return _getMapTileCacheSizeAsync.apply(this, arguments);
      }
      return getMapTileCacheSizeAsync;
    }()
  }, {
    key: "clearMapTileCacheAsync",
    value: function () {
      var _clearMapTileCacheAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(mapID) {
        var source;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!mapID) {
                source = this.from;
              } else {
                source = this.cacheHash[mapID];
              }
              if (source) {
                _context8.next = 3;
                break;
              }
              return _context8.abrupt("return");
            case 3:
              _context8.next = 5;
              return source.clearTileCacheAsync();
            case 5:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function clearMapTileCacheAsync(_x7) {
        return _clearMapTileCacheAsync.apply(this, arguments);
      }
      return clearMapTileCacheAsync;
    }()
  }, {
    key: "fetchAllMapTileCacheAsync",
    value: function () {
      var _fetchAllMapTileCacheAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(mapID, callback) {
        var source;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!mapID) {
                source = this.from;
              } else {
                source = this.cacheHash[mapID];
              }
              if (source) {
                _context9.next = 4;
                break;
              }
              callback("stop", {});
              return _context9.abrupt("return");
            case 4:
              _context9.next = 6;
              return source.fetchAllTileCacheAsync(callback);
            case 6:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function fetchAllMapTileCacheAsync(_x8, _x9) {
        return _fetchAllMapTileCacheAsync.apply(this, arguments);
      }
      return fetchAllMapTileCacheAsync;
    }()
  }, {
    key: "cancelMapTileCacheAsync",
    value: function () {
      var _cancelMapTileCacheAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(mapID) {
        var source;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              if (!mapID) {
                source = this.from;
              } else {
                source = this.cacheHash[mapID];
              }
              if (source) {
                _context10.next = 3;
                break;
              }
              return _context10.abrupt("return");
            case 3:
              _context10.next = 5;
              return source.cancelTileCacheAsync();
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function cancelMapTileCacheAsync(_x10) {
        return _cancelMapTileCacheAsync.apply(this, arguments);
      }
      return cancelMapTileCacheAsync;
    }()
  }, {
    key: "convertParametersFromCurrent",
    value: function convertParametersFromCurrent(to, callback) {
      var _this23 = this;
      var view = this.mapObject.getView();
      var fromPromise = this.from.viewpoint2MercsAsync();
      var current = recursiveRound([view.getCenter(), view.getZoom(), view.getRotation()], 10);
      if (this.mercBuffer && this.mercBuffer.mercs && this.mercBuffer.buffer[this.from.mapID]) {
        var buffer = this.mercBuffer.buffer[this.from.mapID];
        if (buffer[0][0] == current[0][0] && buffer[0][1] == current[0][1] && buffer[1] == current[1] && buffer[2] == current[2]) {
          this.logger.debug(buffer);
          this.logger.debug(current);
          this.logger.debug("From: Use buffer");
          fromPromise = new Promise(function (res, _rej) {
            res(_this23.mercBuffer.mercs);
          });
        } else {
          this.mercBuffer = {
            buffer: {}
          };
          this.mercBuffer.buffer[this.from.mapID] = current;
        }
      } else {
        this.mercBuffer = {
          buffer: {}
        };
        this.mercBuffer.buffer[this.from.mapID] = current;
      }
      this.logger.debug("From: Center: ".concat(current[0], " Zoom: ").concat(current[1], " Rotation: ").concat(current[2]));
      this.logger.debug("From: ".concat(this.from.mapID));
      fromPromise.then(function (mercs) {
        _this23.mercBuffer.mercs = mercs;
        _this23.logger.debug("Mercs: ".concat(mercs));
        var toPromise = to.mercs2ViewpointAsync(mercs);
        var key = to.mapID;
        if (_this23.mercBuffer.buffer[key]) {
          _this23.logger.debug("To: Use buffer");
          toPromise = new Promise(function (res, _rej) {
            res(_this23.mercBuffer.buffer[key]);
          });
        }
        toPromise.then(function (size) {
          _this23.logger.debug("To: Center: ".concat(size[0], " Zoom: ").concat(size[1], " Rotation: ").concat(size[2]));
          _this23.logger.debug("To: ".concat(to.mapID));
          _this23.mercBuffer.buffer[to.mapID] = recursiveRound(size, 10);
          callback(size);
        }).catch(function (err) {
          throw err;
        });
      }).catch(function (err) {
        throw err;
      });
    }
  }, {
    key: "translate",
    value: function translate(dataFragment) {
      var _this24 = this;
      if (!dataFragment || typeof dataFragment === "string") return dataFragment;
      var langs = Object.keys(dataFragment);
      var key = langs.reduce(function (prev, curr, idx, arr) {
        if (curr == _this24.appLang) {
          prev = [dataFragment[curr], true];
        } else if (!prev || curr == "en" && !prev[1]) {
          prev = [dataFragment[curr], false];
        }
        if (idx == arr.length - 1) return prev[0];
        return prev;
      }, undefined);
      key = typeof key === "string" ? key : "".concat(key);
      if (this.i18n.exists(key, {
        ns: "translation",
        nsSeparator: "__X__yX__X__"
      })) return this.t(key, {
        ns: "translation",
        nsSeparator: "__X__yX__X__"
      });
      for (var i = 0; i < langs.length; i++) {
        var lang = langs[i];
        this.i18n.addResource(lang, "translation", key, dataFragment[lang]);
      }
      return this.t(key, {
        ns: "translation",
        nsSeparator: "__X__yX__X__"
      });
    }
  }, {
    key: "remove",
    value: function remove() {
      if (this.mapboxMap) {
        this.mapboxMap.remove();
      }
      this.mapDivDocument.innerHTML = "";
      this.mapDivDocument.classList.remove("maplat");
    }
  }]);
  return MaplatApp;
}(EventTarget);
export { createElement };
export { CustomEvent };